import { type GuestUserParams } from '@/features/account/services/GuestUser/types'
import {
  EMPTY_GUEST_PARAMS,
  GUEST_PARAMS_QUERY_KEY,
} from '@/features/account/services/GuestUser/constants'
import { getQueryClient } from '@/features/shared/utils/dataFetching/reactQuery/SegwayQueryClient'

// Kept out of queryOptions.ts (which imports the guest fetchers) so cache readers
// like analytics don't pull the fetchers -> dataFetching -> analytics import cycle.
export const getGuestParamsFromCache = (): GuestUserParams =>
  getQueryClient().getQueryData<GuestUserParams>(GUEST_PARAMS_QUERY_KEY) ?? EMPTY_GUEST_PARAMS
